import { LoaderCircle } from "lucide-react"

interface ProcessingStateProps {
  title?: string
  description?: string
  className?: string
  titleClassName?: string
  descriptionClassName?: string
  spinnerClassName?: string
}

export default function ProcessingState({
  title = 'Захиалга үүслээ',
  description = 'Захиалгын хуудас руу шилжиж байна. Түр хүлээнэ үү.',
  className = '',
  titleClassName = 'text-foreground',
  descriptionClassName = 'text-muted-foreground',
  spinnerClassName = 'text-foreground',
}: ProcessingStateProps) {
  return (
    <div className={`w-full flex flex-col items-center justify-center text-center gap-4 py-16 px-6 ${className}`}>
      <LoaderCircle className={`size-8 animate-spin ${spinnerClassName}`} />
      <div className="max-w-sm">
        <div className={`text-lg leading-8 tracking-[.0125em] font-gilroy font-semibold ${titleClassName}`}>{title}</div>
        {description && <p className={`mt-1 text-sm font-normal leading-5 ${descriptionClassName}`}>{description}</p>}
      </div>
    </div>
  )
}
